import URI from "urijs";
import $ from "jquery";

/**
 * Gets parsed URI
 */
function _getCurrentUri() {
  return URI(window.location.hash ? window.location.hash.substring(1) : "");
}

export function getShareUrl(sharePath) {
  var uri = new URI(`${window.location.origin}${sharePath}`);

  return uri.toString();
}

/**
 * Sets URI params
 */
export function getUrlFromParams(params) {
  var uri = new URI("/");
  uri.setSearch(params);

  return uri.toString();
}

/**
 * Merges given object as param in URL #params
 */
export function setUrlParams(newParams) {
  var params = getCurrentUrlParams();

  for(let key in newParams) {
    let value = newParams[key];
    params[key] = value;
  }

  window.location.hash = "#" + getUrlFromParams(params);
}

/**
 * Returns parsed params
 */
export function getCurrentUrlParams() {
  return _getCurrentUri().search(true);
}

/**
 * Returns the current filtered search query from the URL
 */
export function getSearchQueryFromUrl() {
  return $.trim(getCurrentUrlParams().q || "");
}



// WEBPACK FOOTER //
// ./app/javascript/portal/documents/url_utils.js